import React from 'react';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { CommonBreadcrumbProps } from '../types/common.types';

const CommonBreadcrumb: React.FC<CommonBreadcrumbProps> = ({
  items,
  separator = <NavigateNextRoundedIcon fontSize="small" />,
}) => {
  return (
    <Breadcrumbs separator={separator} aria-label="breadcrumb" sx={{ fontSize: 13, '& .MuiSvgIcon-root': { fontSize: 16 } }}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast || item.isActive || !item.onClick) {
          return (
            <Typography key={`${item.label}-${index}`} color="text.primary" fontWeight={600} sx={{ fontSize: 13 }}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={`${item.label}-${index}`}
            component="button"
            type="button"
            underline="hover"
            color="inherit"
            onClick={item.onClick}
            sx={{ cursor: 'pointer', fontWeight: 500, fontSize: 13 }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default CommonBreadcrumb;
